const getKey = (widgetId, slotId) => `${widgetId}-${slotId}`;
export const canOpenModal = (plugins, slots) => {
  if (!plugins.length || !slots.length) {
    return false;
  }
  const slotMap = new Map();
  slots.forEach(slot => {
    const key = getKey(slot.widgetId, slot.slotId);
    slotMap.set(key, true);
  });
  return plugins.every(plugin => plugin.placements.some(placement => {
    const key = getKey(placement.widgetId, placement.slotId);
    return slotMap.has(key);
  }));
};
//# sourceMappingURL=canOpenModal.js.map